/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { DateTime } from 'luxon'
import { useAuthentication } from '@hooks/useAuthentication'
import { UserReadingToLocalProps } from './interface'
import { useUserReadingAction } from '@hooks/userReading/useUserReadingAction'

export function UserReadingToLocal({
  chapterId,
  bookId,
  writerUserId,
  chapterPageId,
  readingPercentage,
}: UserReadingToLocalProps) {
  const userReadingClient = useUserReadingAction()
  const { isAuthenticated } = useAuthentication()

  async function setUserReadingToLocal() {
    const localStorageData = await userReadingClient.getGuestReading(true)
    const newData = {
      id: DateTime.utc().valueOf(),
      bookId,
      chapterId,
      writerUserId: writerUserId || 0,
      chapterPageId: chapterPageId || 0,
      readingPercentage: readingPercentage || 0,
      updatedAt: DateTime.utc().toString(),
    }

    if (!localStorageData.length) {
      userReadingClient.replaceGuestReading([newData])
    } else {
      const temp = localStorageData.filter(row => row.bookId !== bookId)

      if (temp.length >= 3) {
        temp.pop()
      }

      userReadingClient.replaceGuestReading([newData, ...temp])
    }
  }
  useEffect(() => {
    if (!isAuthenticated) {
      setUserReadingToLocal()
    }
  }, [isAuthenticated, chapterId])

  return null
}
